import { TileTypes } from 'generated/graphql-types';

export enum ChartDisplayType {
   VerticalBar = 'VerticalBar',
   HorizontalBar = 'HorizontalBar',
   VerticalLine = 'VerticalLine',
   Pie = 'Pie',
   PieGrid = 'PieGrid',
   // FUTURE: support other chart types
}
export const chartTileTypeMap = {
   [TileTypes.BarGraph]: ChartDisplayType.VerticalBar,
   [TileTypes.PieGraph]: ChartDisplayType.Pie,
   [TileTypes.PieGridGraph]: ChartDisplayType.PieGrid,
   [TileTypes.LineGraph]: ChartDisplayType.VerticalLine,
};
